import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

import AaSequencePreview from './AaSequencePreview';

const AA_SEQUENCE_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.PROTEIN,
  preview: AaSequencePreview,
});

export default AA_SEQUENCE_PREVIEW_PLUGIN;
